import   axios                         from 'axios';

import { API_URLS } from '../urls';


export interface InformationsFromYoutube {
  code:           number,
  comment:        string,
  youtubeVideoId: string,
  publishedAt:    string,
  title:          string,
  description:    string,
  thumbnailUrl:   string,
  duration:       string,
  numberOfViews:  number ,
  ranking:        number
}

export const getInformationsFromYoutube = async ( youtubeId: string ) : Promise<InformationsFromYoutube>  => {

	const baseUrl  =  `${API_URLS.getInformationsFromYoutube}?`;

    const name1  = "youtubeId=";
    const value1 = encodeURIComponent ( youtubeId );

    var url = `${baseUrl}${name1}${value1}`;

	//const userAgentInformations = getUserAgentInformations ();
	//const appInformations       = getAppInformations ();

    const headers = {
      //    'User-Agent-Informations': `${userAgentInformations}`,
	  //    'App-Informations': `${appInformations}`,
    };

    var result:InformationsFromYoutube = {
      code:           0  ,
	  comment:        "" ,
      youtubeVideoId: youtubeId ,
      publishedAt:    "" ,
      title:          "" ,
      description:    "" ,
      thumbnailUrl:   "" ,
      duration:       "" ,
      numberOfViews:  0  ,
      ranking:        0
    };


    try {

      const response = await axios.get ( url, { headers: headers } );

      const statut = response.status;

      if ( statut === 200  )
             {
			  result = {
                code:           1,
                comment:        "Récupération des informations de la video Youtube",
                youtubeVideoId: response.data.youtubeVideoId ,
                publishedAt:    response.data.publishedAt    ,
                title:          response.data.title          ,
                description:    response.data.description    ,
                thumbnailUrl:   response.data.thumbnailUrl   ,
                duration:       response.data.duration       ,
                numberOfViews:  response.data.numberOfViews  ,
                ranking:        response.data.ranking
              };
             }
        else {
              result = {
                code:           -101,
                comment:        `Erreur lors de la récupération des informations concernant les chaînes de diffusion : ${response.status}`,
                youtubeVideoId: youtubeId ,
                publishedAt:    "" ,
                title:          "" ,
                description:    "" ,
                thumbnailUrl:   "" ,
                duration:       "" ,
                numberOfViews:  0  ,
                ranking:        0
              };
             }
    }
    catch (error) {

     result = {
       code:           -201,
 	   comment:        "Erreur réseau",
       youtubeVideoId: youtubeId ,
       publishedAt:    "" ,
       title:          "" ,
       description:    "" ,
       thumbnailUrl:   "" ,
       duration:       "" ,
       numberOfViews:  0  ,
       ranking:        0
     };
    }

    return result;
}
